export default __webpack_public_path__ + "static/media/svg.271a90c4.svg";